import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { MapPin, Settings2, BookOpen } from "lucide-react";

const DISTRICTS = ["Lisboa", "Porto", "Braga", "Setúbal", "Faro", "Coimbra", "Madeira", "Açores"];

export const Footer = () => (
  <footer className="bg-slate-950 text-slate-400">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
      <div className="md:col-span-2">
        <Logo size="md" variant="light" tagline="Emprego em Portugal" />
        <p className="text-sm leading-relaxed max-w-sm mt-5">
          A plataforma de emprego para os setores que nunca param: restauração, logística, retalho,
          limpeza e mais. Cobertura nacional (308 concelhos), grátis para candidatos.
        </p>
        <div className="flex flex-wrap gap-2 mt-6">
          {DISTRICTS.map((d) => (
            <Link key={d} to={`/empregos?district=${encodeURIComponent(d)}`}
              className="inline-flex items-center gap-1.5 text-xs border border-white/10 rounded-full px-3 py-1.5 hover:border-amber-400 hover:text-amber-300 transition-colors">
              <MapPin className="w-3 h-3" /> {d}
            </Link>
          ))}
        </div>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-4">Plataforma</p>
        <div className="flex flex-col gap-2.5 text-sm">
          <Link to="/empregos" className="hover:text-white transition-colors">Procurar empregos</Link>
          <Link to="/#como-funciona" className="hover:text-white transition-colors">Como funciona</Link>
          <Link to="/casos-de-estudo" className="hover:text-white transition-colors">Casos de estudo</Link>
          <Link to="/#precos" className="hover:text-white transition-colors">Preços para empresas</Link>
          <Link to="/#faq" className="hover:text-white transition-colors">Perguntas frequentes</Link>
        </div>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-4">Empresas</p>
        <div className="flex flex-col gap-2.5 text-sm">
          <Link to="/auth?tab=register" className="hover:text-white transition-colors">Publicar vaga</Link>
          <Link to="/#visao" className="hover:text-white transition-colors">A nossa visão</Link>
        </div>
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-4 mt-8">Legal</p>
        <div className="flex flex-col gap-2.5 text-sm">
          <Link to="/legal/termos-e-condicoes" className="hover:text-white transition-colors">Termos e Condições</Link>
          <Link to="/legal/politica-de-privacidade" className="hover:text-white transition-colors">Privacidade (RGPD)</Link>
          <Link to="/legal/politica-de-cookies" className="hover:text-white transition-colors">Política de Cookies</Link>
          <Link to="/legal/politica-de-reembolso" className="hover:text-white transition-colors">Reembolsos e cancelamentos</Link>
          <Link to="/legal/aviso-legal" className="hover:text-white transition-colors">Aviso legal</Link>
          <button type="button" data-testid="footer-cookie-prefs"
            onClick={() => window.dispatchEvent(new Event("f2j:open-cookie-prefs"))}
            className="inline-flex items-center gap-1.5 text-left hover:text-white transition-colors">
            <Settings2 className="w-3.5 h-3.5" /> Preferências de cookies
          </button>
          <a href="https://www.livroreclamacoes.pt/inicio" target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-1.5 hover:text-white transition-colors">
            <BookOpen className="w-3.5 h-3.5" /> Livro de Reclamações
          </a>
        </div>
      </div>
    </div>
    <div className="border-t border-white/5 py-6 px-4 flex flex-col sm:flex-row items-center justify-center gap-2 text-center text-xs text-slate-600">
      <span>© 2026 FIRST2JOB — Feito em Portugal</span>
      <span className="hidden sm:inline">·</span>
      <span>Pagamentos seguros por Stripe</span>
      <span className="hidden sm:inline">·</span>
      <Link to="/legal" className="hover:text-slate-300 transition-colors">Informação legal</Link>
    </div>
  </footer>
);
